import { useState } from "react";
import Button from "ui/buttons/Button";
import Drawer from "./Drawer";

A panel that slides in from the right over a dimmed backdrop. Built on Radix Dialog, so it handles
focus trapping, Esc-to-close, and accessibility automatically. It is product-agnostic — pass a
`title` and arbitrary `children`.

## Basic Usage

export function BasicDrawer() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="secondary" onClick={() => setOpen(true)}>
        Open Drawer
      </Button>
      <Drawer open={open} onOpenChange={setOpen} title="Edit Mapping">
        <div style={{ padding: "18px 24px" }}>
          <p>Drawer content goes here.</p>
        </div>
      </Drawer>
    </>
  );
}

<BasicDrawer />

---

## With Title Actions

export function DrawerWithActions() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="secondary" onClick={() => setOpen(true)}>
        Open with actions
      </Button>
      <Drawer
        open={open}
        onOpenChange={setOpen}
        title="Edit Mapping"
        titleActions={
          <Button btnStyle="link" btnSize="small" onClick={() => setOpen(false)}>
            Save
          </Button>
        }
      >
        <div style={{ padding: "18px 24px" }}>
          <p>The header can host extra actions beside the close button.</p>
        </div>
      </Drawer>
    </>
  );
}

<DrawerWithActions />
